import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React from "react";

function RadioButton({ val, handleChange, option1, option2 }) {
  return (
    <div>
      <FormControl>
        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
        <RadioGroup
          style={{ flexDirection: "row", justifyContent: "space-between", width: '350px', margin: 10}}
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={val}
          onChange={handleChange}
        >
          <FormControlLabel
            value={option1}
            control={<Radio />}
            label={option1}
          />
          <FormControlLabel
            value={option2}
            control={<Radio />}
            label={option2}
          />
        </RadioGroup>
      </FormControl>
    </div>
  );
}

export default RadioButton;
